module.exports = __webpack_public_path__ + "img/teaching_2.b904138b.png";